import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faBullseye,
  faDrawPolygon,
  faLongArrowAltRight,
  faPaintBrush,
  faQuestionCircle,
  faSlash,
  faTag,
  faVectorSquare,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactElement } from 'react';

export const enum IconType {
  MarkingToolPoint = 'MarkingToolPoint',
  MarkingToolRectangle = 'MarkingToolRectangle',
  MarkingToolVector = 'MarkingToolVector',
  MarkingToolPolyline = 'MarkingToolPolyline',
  MarkingToolPolygon = 'MarkingToolPolygon',
  MarkingToolRotatedRectangle = 'MarkingToolRotatedRectangle',
  MarkingToolBrush = 'MarkingToolBrush',
  Attribute = 'Attribute',
  Question = 'Question',
}

library.add(faBullseye, faLongArrowAltRight, faSlash, faDrawPolygon, faVectorSquare, faPaintBrush, faTag, faQuestionCircle);

interface IProps {
  iconType: IconType;
  tooltip: string;
  color?: string;
}

export const AnnotationToolIcon = ({ iconType, tooltip, color }: IProps): ReactElement => (
  <>
    {iconType === IconType.MarkingToolPoint && (
      <FontAwesomeIcon
        className='annotation-tool-icon marking-tool-icon'
        icon={faBullseye}
        css={{ color }}
        title={tooltip}
      />
    )}
    {iconType === IconType.MarkingToolRectangle && (
      <FontAwesomeIcon
        className='annotation-tool-icon marking-tool-icon'
        icon={faVectorSquare}
        css={{ color }}
        title={tooltip}
      />
    )}
    {iconType === IconType.MarkingToolVector && (
      <FontAwesomeIcon
        className='annotation-tool-icon marking-tool-icon'
        icon={faLongArrowAltRight}
        css={{ color }}
        title={tooltip}
      />
    )}
    {iconType === IconType.MarkingToolPolyline && (
      <FontAwesomeIcon
        className='annotation-tool-icon marking-tool-icon'
        icon={faSlash}
        css={{ color }}
        title={tooltip}
      />
    )}
    {iconType === IconType.MarkingToolPolygon && (
      <FontAwesomeIcon
        className='annotation-tool-icon marking-tool-icon'
        icon={faDrawPolygon}
        css={{ color }}
        title={tooltip}
      />
    )}
    {iconType === IconType.MarkingToolRotatedRectangle && (
      <FontAwesomeIcon
        className='annotation-tool-icon marking-tool-icon rotated-rectangle'
        icon={faVectorSquare}
        css={{ color }}
        title={tooltip}
      />
    )}
    {iconType === IconType.MarkingToolBrush && (
      <FontAwesomeIcon
        className='annotation-tool-icon marking-tool-icon'
        icon={faPaintBrush}
        css={{ color }}
        title={tooltip}
      />
    )}
    {iconType === IconType.Attribute && (
      <FontAwesomeIcon
        className='annotation-tool-icon attribute-icon'
        icon={faTag}
        title={tooltip}
      />
    )}
    {iconType === IconType.Question && (
      <FontAwesomeIcon
        className='annotation-tool-icon question-icon'
        icon={faQuestionCircle}
        title={tooltip}
      />
    )}
  </>
);
